import { axiosInstance as axios, handleAxiosErrors } from '../_utils';
import {
    convertDataToListingDisplay,
    convertProductSalePricesToAReadableFormat,
    convertProductsListingToAReadableFormat,
    escapeGraphQLInput,
    getProductsListingRelatedProductIDs,
} from '../selectors/converterSelector';
import config from '../store/_config';
import {
    axiosRequestProductsByIDs,
    axiosRequestSellPriceByBuyableIDs,
} from './productActions';

export const toggleLoading = (value) => {
    return {
        type: 'TOGGLE_PRODUCT_VARIATION_LIST_LOADING',
        value: value,
    };
};
export const updateHasInitialized = (value) => {
    return {
        type: 'UPDATE_PRODUCT_VARIATION_LIST_HAS_INITIALIZED',
        value: value,
    };
};
export const replaceProductVariationListDisplay = (value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'UPDATE_PRODUCT_VARIATION_LIST_DISPLAY',
            value: value,
        });
    };
};
export const updateProductVariationList = (value) => {
    return {
        type: 'UPDATE_PRODUCT_VARIATION_LIST',
        value: value,
    };
};
export const updateRelatedProducts = (value) => {
    return {
        type: 'UPDATE_PRODUCT_VARIATION_RELATED_PRODUCT_LIST',
        value: value,
    };
};
export const setActivePage = (value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'SET_PRODUCT_VARIATION_LIST_ACTIVE_PAGE',
            value: value,
        });

        dispatch(requestProductVariations());
    };
};
export const setTotalRecords = (value) => {
    return {
        type: 'SET_PRODUCT_VARIATION_LIST_TOTAL_RECORDS',
        value: value,
    };
};
export const requestProductVariations = () => {
    return (dispatch, getState) => {
        const familyTitleSlug = typeof window.familyTitleSlug != 'undefined' ? window.familyTitleSlug : '';

        if (!familyTitleSlug) {
            console.error('Error: No family title given, aborting request');
            return;
        }

        let { url, query } = config.product.variations;
        query = query.replace(/{familyTitleSlug}/, escapeGraphQLInput(familyTitleSlug));

        dispatch(toggleLoading(true));

        return axios
            .get(url, {
                params: {
                    query: query,
                },
            })
            .then((response) => {
                const list = convertProductsListingToAReadableFormat(
                    response.data.data.readProducts
                );
                const listingDisplay = convertDataToListingDisplay(
                    response.data.data.readProducts,
                    'ID'
                );
                const relatedProductIDs = getProductsListingRelatedProductIDs(
                    response.data.data.readProducts
                );

                // wait for async requests
                Promise.all([
                    dispatch(
                        replaceProductVariationListDisplay(listingDisplay)
                    ),
                    dispatch(updateProductVariationList(list)),
                ]).then(() => {
                    dispatch(updateHasInitialized(true));
                    dispatch(toggleLoading(false));
                    dispatch(requestSellPrice(listingDisplay));
                    dispatch(requestRelatedProducts(relatedProductIDs));
                });
            })
            .catch((error) => {
                dispatch(updateHasInitialized(true));
                dispatch(toggleLoading(false));
                handleAxiosErrors(error);
            });
    };
};
export const requestSellPrice = (buyableIDs) => {
    return (dispatch, getState) => {
        return axiosRequestSellPriceByBuyableIDs(buyableIDs).then(
            (response) => {
                const prices = convertProductSalePricesToAReadableFormat(
                    response.data.data.readBuyablePrices
                );

                dispatch(updateProductVariationList(prices));
            }
        );
    };
};
export const requestRelatedProductSellPrice = (buyableIDs) => {
    return (dispatch, getState) => {
        return axiosRequestSellPriceByBuyableIDs(buyableIDs).then(
            (response) => {
                const prices = convertProductSalePricesToAReadableFormat(
                    response.data.data.readBuyablePrices
                );

                dispatch(updateRelatedProducts(prices));
            }
        );
    };
};
export const requestRelatedProducts = (ids) => {
    return (dispatch, getState) => {
        const LIMIT = 10;

        if (ids.length == 0) {
            return Promise.resolve({});
        }

        return axiosRequestProductsByIDs(ids.slice(0, LIMIT)).then(
            (response) => {
                const list = convertProductsListingToAReadableFormat(
                    response.data.data.readProducts
                );
                const listingDisplay = convertDataToListingDisplay(
                    response.data.data.readProducts,
                    'ID'
                );

                // wait for async requests
                Promise.all([dispatch(updateRelatedProducts(list))]).then(
                    () => {
                        dispatch(
                            requestRelatedProductSellPrice(listingDisplay)
                        );
                    }
                );
            }
        );
    };
};
